import { useEffect } from "react";
import Lenis from "lenis";
import { HashRouter, Routes, Route } from "react-router-dom";
import "@/App.css";

import { Header } from "@/components/site/Header";
import { Hero } from "@/components/site/Hero";
import { EditorialMarquee } from "@/components/site/Marquee";
import { Manifesto } from "@/components/site/Manifesto";
import { Stats } from "@/components/site/Stats";
import { Acoes } from "@/components/site/Acoes";
import { Galeria } from "@/components/site/Galeria";
import { Membro } from "@/components/site/Membro";
import { Contato } from "@/components/site/Contato";
import { Footer } from "@/components/site/Footer";
import ProjetoMeninasVencedoras from "@/pages/ProjetoMeninasVencedoras";

function HomePage() {
    return (
        <div className="App" data-testid="site-root">
            <div className="noise" aria-hidden="true" />
            <Header />
            <main>
                <Hero />
                <EditorialMarquee />
                <Manifesto />
                <Stats />
                <Acoes />
                <Galeria />
                <Membro />
                <Contato />
            </main>
            <Footer />
        </div>
    );
}

function App() {
    useEffect(() => {
        document.title =
            "AENHCC · Associação Esportiva Novo Horizonte de Canaã dos Carajás";

        const lenis = new Lenis({
            lerp: 0.09,
            duration: 1.25,
            smoothWheel: true,
            smoothTouch: false,
        });

        let rafId;
        const raf = (time) => {
            lenis.raf(time);
            rafId = requestAnimationFrame(raf);
        };
        rafId = requestAnimationFrame(raf);

        return () => {
            cancelAnimationFrame(rafId);
            lenis.destroy();
        };
    }, []);

    return (
        <HashRouter>
            <Routes>
                <Route path="/" element={<HomePage />} />
                <Route
                    path="/projeto-meninas-vencedoras"
                    element={<ProjetoMeninasVencedoras />}
                />
                <Route path="*" element={<HomePage />} />
            </Routes>
        </HashRouter>
    );
}

export default App;
